import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useBetterAuthConvexAuth } from '../../hooks/useAppAuth';

const Header: React.FC = () => {
  const { signOut, convexUser } = useBetterAuthConvexAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    await signOut();
  };

  return (
    <header className="bg-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20 sm:h-24">
          <div className="flex items-center">
            <a href="https://www.ashadegreener.co.uk">
              <img
                src="/ASG_Maintenance_side.png"
                alt="A Shade Greener Maintenance"
                className="h-12 sm:h-16 md:h-20 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="https://www.ashadegreener.co.uk"
              className="text-sm lg:text-base text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md hover:bg-gray-50"
            >
              Return to main site
            </a>
            {convexUser && (
              <Link
                to="/dashboard/change-password"
                className="text-sm lg:text-base text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md hover:bg-gray-50"
              >
                Change Password
              </Link>
            )}
            <div className="flex items-center space-x-3">
              {convexUser && (
                <div className="flex items-center space-x-2">
                  <div className="text-sm w-10 h-10 rounded-full bg-[#16A34A]  flex items-center justify-center text-white font-medium">
                    {(convexUser.name || convexUser.username || '?')[0].toUpperCase()}
                  </div>
                  {convexUser.username && (
                    <span className="hidden lg:inline text-sm text-gray-500">
                      {convexUser.username.toUpperCase()}
                    </span>
                  )}
                </div>
              )}
              <button
                onClick={handleLogout}
                className="text-sm lg:text-base text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md hover:bg-gray-50"
              >
                Sign out
              </button>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-shade-green-500"
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white">
          <div className="px-4 py-2 space-y-1">
            <a
              href="https://www.ashadegreener.co.uk"
              className="block py-3 px-3 text-base text-gray-700 hover:bg-gray-50 rounded-md"
              onClick={() => setIsMenuOpen(false)}
            >
              Return to main site
            </a>
            {convexUser && (
              <Link
                to="/dashboard/change-password"
                className="block py-3 px-3 text-base text-gray-700 hover:bg-gray-50 rounded-md"
                onClick={() => setIsMenuOpen(false)}
              >
                Change Password
              </Link>
            )}
            <button
              onClick={() => {
                handleLogout();
                setIsMenuOpen(false);
              }}
              className="block w-full text-left py-3 px-3 text-base text-gray-700 hover:bg-gray-50 rounded-md"
            >
              Log out
            </button>
          </div>
          {convexUser?.username && (
            <div className="px-4 py-2 border-t border-gray-200">
              <p className="text-sm text-gray-500">Logged in as: {convexUser.username.toUpperCase()}</p>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;
